import { FaFacebook, FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";

function Footer() {
  return (
    <motion.footer
      className="bg-background text-gray-400 py-10 px-4 mt-20"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className="max-w-6xl mx-auto flex flex-col items-center gap-4">
        <motion.p
          className="text-sm md:text-base text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          © {new Date().getFullYear()} Chilsmart. Todos los derechos reservados.
        </motion.p>

        <motion.div
          className="flex space-x-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <a
            href="https://www.facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-500 hover:text-indigo-300 transition-transform transform hover:scale-110"
          >
            <FaFacebook size={28} />
          </a>
          <a
            href="https://www.instagram.com/chilsmartsolutions/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-500 hover:text-indigo-300 transition-transform transform hover:scale-110"
          >
            <FaInstagram size={28} />
          </a>
        </motion.div>
      </div>
    </motion.footer>
  );
}

export default Footer;
